import {
  fetchPasswordResetDetails,
  submitPasswordResetConfirmation,
} from 'actions/authentication';
import FormSubmitButton from 'components/FormElements/FormSubmitButton';
import FormTextField from 'components/FormElements/FormTextField';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field, getFormValues, reduxForm } from 'redux-form';
import queryString from 'utils/libraries/query-string';
import { Required } from 'utils/validators';
import './index.scss';

class ConfirmResetForm extends Component {
  componentWillMount() {
    let params = queryString.parse(this.props.location.search);

    if (params.verification) {
      this.props.fetchPasswordResetDetails(params.verification);
    }
  }

  submitResetConfirmation = () => {
    let params = queryString.parse(this.props.location.search);

    const { email, pwd } = this.props.formValues;
    this.props.submitPasswordResetConfirmation(email, pwd, params.verification);
  };

  render() {
    const disableSubmitButton =
      this.props.resetEmailAddress === undefined || this.props.didResetPassword;

    return (
      <div>
        <form>
          <input
            style={{ height: '1px', opacity: 0 }}
            type="password"
            name="fuckchrome"
          />

          <Field
            disabled={true}
            name="email"
            autoComplete="off"
            type="email"
            margin="normal"
            fullWidth
            component={FormTextField}
            validate={[Required]}
            label="Email Address"
          />
          <Field
            name="pwd"
            type="password"
            autoComplete="off"
            margin="normal"
            placeholder="password"
            fullWidth
            component={FormTextField}
            validate={[Required]}
            label="New Password"
          />

          <FormSubmitButton
            disabled={disableSubmitButton}
            onClick={this.submitResetConfirmation}
            className="confirm__reset__submit"
            loading={this.props.loading}
          >
            Confirm
          </FormSubmitButton>
        </form>

        <div className="confirm__reset__error" role="alert">
          {this.props.resetConfirmationError.detail}
        </div>
        <div className="confirm__reset__success" role="alert">
          {this.props.didResetPassword
            ? 'Your password has been successfully reset.'
            : ''}
        </div>

        <Link className="forgot__password__link" to="./login">
          Return to Login
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    formValues: getFormValues('confirm-reset')(state) || {},
    loading: state.authentication.loading,
    resetConfirmationError: state.authentication.resetConfirmationError,
    resetEmailAddress: state.authentication.resetEmailAddress,
    didResetPassword: state.authentication.didResetPassword,
    initialValues: state.authentication.formData['confirm-reset'],
  };
};

const mapDispatchToProps = dispatch => ({
  fetchPasswordResetDetails: resetID =>
    dispatch(fetchPasswordResetDetails(resetID)),
  submitPasswordResetConfirmation: (email, newPassword, resetID) =>
    dispatch(submitPasswordResetConfirmation(email, newPassword, resetID)),
});

ConfirmResetForm = reduxForm({
  form: 'confirm-reset',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(ConfirmResetForm);

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmResetForm);



// WEBPACK FOOTER //
// ./src/components/Authentication/ConfirmResetForm/index.jsx